<template>
    <div class="container feedback template-bg-gray my-position-relative">
        <md-card class="request-status loop_container bg-transparent update-request-form-common">
            <md-card-content class="col-lg-12 col-md-12 col-sm-12 col-xs-12 main">
                <div class="card form-wrapper text-center p-20">
                    <h4 class="template-custom-title" v-if="!message.length">checking...</h4>
                    <h4 class="template-custom-title" else>{{message}}</h4>
                </div>
            </md-card-content>
	    </md-card>
    </div>
</template>

<script>
import API from "../services/API";
export default {
    name: 'UpdateMemberProfileChange',
    data() {
        return {
            fullPage: true,
            api: new API(),
            message: ''
        }
    },
    beforeCreate() {
        if (!this.$route.query.changeId || !this.$route.query.action) {
            this.$router.push('/');
        }
    },
    async created() {
        await this.api.get(`members/editProfile/${this.$route.query.changeId}`).then(async changeData => {
            if (changeData.data.status === 'blank') {
                await this.api.post(`members/updateProfileChange`, {changeId: this.$route.query.changeId, action: this.$route.query.action}).then(response => {
                    this.message = 'Thank you';
                    if (response.data) {
                        if (this.$route.query.action === 'approve') {
                            this.message = 'Thank you for approving profile changes.';
                        } else if (this.$route.query.action === 'decline') {
                            this.message = 'Thank you for your response';
                        }
                    }
                });
            } else {
                this.message = 'Thank you';
            }
        })
    }
}
</script>



// WEBPACK FOOTER //
// src/components/UpdateMemberProfileChange.vue